'use strict';

module.exports = {
  MIN_LENGTH: 12,
  MIN_UPPERCASE: 1,
  MIN_LOWERCASE: 1,
  MIN_NUMBERS: 1,
  MIN_SYMBOLS: 0,
};
